import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-civil-law',
  templateUrl: './civil-law.component.html',
  styleUrls: ['./civil-law.component.css']
})
export class CivilLawComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
